import React, {Component} from 'react';
import {Settings} from "../Utils/Settings";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import Grid from '@material-ui/core/Grid';
import {Helmet} from "react-helmet";
import Typography from "@material-ui/core/es/Typography/Typography";
import Helpers from "../Utils/Helpers";
import Card from '@material-ui/core/Card';
import Button from "@material-ui/core/Button";

import {
    FacebookShareButton,
    TwitterShareButton,
    PinterestShareButton,
    EmailShareButton,
} from 'react-share';

import {
    FacebookIcon,
    TwitterIcon,
    PinterestIcon,
    EmailIcon,
} from 'react-share';

import { Link } from "react-router-dom"
import { PrintButton} from "./Buttons";
import FinancingCalculator from "./FinancingCalculator";

class DetailsPart extends Component {

    render() {

        const details = this.props.searchDetailsRecord;

        if (!details) {
            return "";
        }

        let images = [];
        let firstImage = "";

        for (let index = 1; index <= 10; index++) {
            let image = details["t_xpath" + index][0];
            let thumbnail = details["t_xpathth" + index][0];
            let caption = details["t_com" + index][0];
            if (image && image.length > 0) {
                if (firstImage.length === 0) {
                    firstImage = image;
                }

                images.push({
                    original: image,
                    thumbnail: thumbnail,
                    description: caption
                });
            }
        }

        let normalPrice = parseFloat(details.t_price[0]).toFixed(0);

        let pageTitle = details.t_year[0] + " " + details.t_make[0] + " " + details.t_model[0];
        let pageCanonicalUrl = details.URL[0];

        let trackingImage = "https://dashboard.equinemediaworld.com/Listing/Impression?lt=" + Settings.inventoryTypes.TRUCK + "&id=" + details.t_id[0];
        let shareUrl = Settings.socialShareUseCanonicalUrls ? pageCanonicalUrl : window.location.href;

        return (
            <div>
            <Grid container spacing={24}>
                <Helmet>
                    <title>{pageTitle}</title>
                    <link rel="canonical" href={shareUrl}/>
                    <meta name="og:url" content={shareUrl}/>
                    <meta name="og:image" content={firstImage}/>
                    <meta name="og:type" content="product"/>
                    <meta name="twitter:card" content="summary"/>
                </Helmet>
                <Grid item xs={12}>
                    <Link style={{textDecoration: "none"}} to="/search/trucks"><Button style={{marginBottom: "15px"}} variant="contained" color="default">Back</Button></Link>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='h1'>{pageTitle}</Typography>
                </Grid>
                <Grid item sm={9} xs={12}>
                    <ImageGallery items={images}/>
                </Grid>
                <Grid item sm={3} xs={12}>
                    <Card style={{padding: "10px"}}>
                        <Typography variant='h5'>${Helpers.formatMoney(normalPrice)}<br/></Typography>
                        <Typography variant='body2' style={{lineHeight: 2}}>
                            <strong>Mfg:</strong> {details.t_make[0]}<br/>
                            <strong>Model:</strong> {details.t_model[0]}<br/>
                            <strong>Mileage:</strong> {details.t_mileage[0]}<br/>
                            <strong>Engine:</strong> {details.t_engine[0]}<br/>
                            <strong>Drive:</strong> {details.t_drive}<br/>
                            <strong>Location:</strong> {details.t_city[0]}, {details.t_state[0]}<br/>
                            <strong>Stock:</strong> {details.t_stock[0]}<br/>
                            {details.t_email[0].length > 0 && <React.Fragment><strong>Email:</strong> <a href={"mailto:" + details.t_email[0]}>{details.t_email[0]}</a><br/></React.Fragment>}
                            {details.t_phone[0].length > 0 && <React.Fragment><strong>Phone:</strong> {details.t_phone[0]}<br/></React.Fragment>}
                            {details.t_fax[0].length > 0 && <React.Fragment><strong>Fax:</strong> {details.t_fax[0]}<br/></React.Fragment>}
                            {details.t_cell[0].length > 0 && <React.Fragment><strong>Fax:</strong> {details.t_cell[0]}<br/></React.Fragment>}
                        </Typography>

                        <FacebookShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><FacebookIcon round size={32} /></FacebookShareButton>
                        <TwitterShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><TwitterIcon round size={32} /></TwitterShareButton>
                        <PinterestShareButton style={{display: "inline-block", marginRight: "10px"}} media={firstImage} url={shareUrl}><PinterestIcon round size={32} /></PinterestShareButton>
                        <EmailShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><EmailIcon round size={32} /></EmailShareButton>

                        <Typography align={"right"}><PrintButton/></Typography>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='body1' dangerouslySetInnerHTML={{__html: Helpers.safeHtml(details.t_description[0])}}></Typography>
                    <img alt="" src={trackingImage} />
                </Grid>
            </Grid>
            </div>
        )
    }
}

export default (DetailsPart);

